let site_key: string | null = null
let script_loaded = false

declare global {
  interface Window {
    grecaptcha: {
      ready(cb: () => void): void
      execute(siteKey: string, options: { action: string }): Promise<string>
    }
  }
}

export async function init_recaptcha(key: string): Promise<void> {
  if (script_loaded || !key) return
  site_key = key

  return new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = `https://www.google.com/recaptcha/api.js?render=${key}`
    script.async = true
    script.onload = () => {
      script_loaded = true
      resolve()
    }
    script.onerror = () => reject(new Error('Failed to load reCAPTCHA'))
    document.head.appendChild(script)
  })
}

export async function get_recaptcha_token(action: string): Promise<string | null> {
  if (!site_key || !window.grecaptcha) return null
  const key = site_key

  return new Promise((resolve) => {
    window.grecaptcha.ready(() => { void (async () => {
      try {
        const token = await window.grecaptcha.execute(key, { action })
        resolve(token)
      } catch {
        resolve(null)
      }
    })() })
  })
}
